import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import './assets/css/entrance.css'
import 'normalize.css'
import '../public/fontIcon/iconfont'
import 'animate.css'

Vue.config.productionTip = false

//初始化token和数据
const init = async () => {
  await store.dispatch('init')
}

init()

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app')
